export default __webpack_public_path__ + "static/media/japan_jetro.5bb39507.png";